module.exports = __webpack_public_path__ + "static/media/icon_url_click.995c1268.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_url_click.svg
// module id = 232
// module chunks = 0